import { fetchTranscriptByAppointment } from "../../api/transcript";
import { useQuery } from "@tanstack/react-query";
import LoadingCard from "./LoadingCard";

const Transcript = ({ appointmentId, username }) => {


  const { data, isLoading, error } = useQuery({
    queryKey: ['transcript', appointmentId, username],
    queryFn: () => fetchTranscriptByAppointment(`${username}_${appointmentId}_transcription`, username)
  });

  let full_conversation = ""
  if (!isLoading && data) {
    full_conversation = data.data.full_conversation
      .split(/\r?\n/)
      .map((convo, index) => {
        if (!convo.trim()) {
          return <br key={index} />
        }
        if (convo.trim() === ':') {
          return <br key={index} />
        }
        if (!convo.includes(':')) {
          return (
            <span key={index}>
              {convo}
              <br />
            </span>
          )
        }
        const parts = convo.split(':');
        const speaker = parts.shift()?.trim();
        const conversation = parts.join(':').trim();
        return (
          <span key={index}>
            <strong> {speaker}: </strong>{" "}
            {conversation}
            <br />
          </span>
        )
      })
  }

  if (isLoading) {
    return <LoadingCard message="Processing clinical chatter… stay with us." />;
  }

  if (error) {
    return <LoadingCard />;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-medium">Call Transcript</h3>
        <div className="flex space-x-2">
        </div>
      </div>
      <div className="border rounded p-6 overflow-y-scroll text-neutral-700 max-h-[320px] whitespace-pre-wrap">
        {full_conversation}
      </div>
    </div>
  )
}

export default Transcript